import yup from 'utils/yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState, useContext, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { ICompanyUserForList } from 'domain/entities/CompanyUser/CompanyUser';
import { CompanyMemberQuery } from 'interfaceAdapter/queries/CompanyMember';
import { InviteCompanyUserRepository } from 'interfaceAdapter/repositories/InviteCompanyUser';
import { useModal } from 'ui/components/screens/modals/useModal';

const schema = yup
    .object({
        email: yup.string().email().required(),
    })
    .required();

type inviteForm = yup.InferType<typeof schema>;

export const useMember = () => {
    const diContainer = useContext(diContainerContext);
    const companyMemberQuery = diContainer.resolve(CompanyMemberQuery);
    const inviteCompanyUserRepository = diContainer.resolve(InviteCompanyUserRepository);
    const [memberList, setMemberList] = useState<ICompanyUserForList[]>([]);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [inviting, setInviting] = useState(false);
    const inviteModal = useModal();
    const needProfileModal = useModal();

    const {
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm<inviteForm>({
        resolver: yupResolver(schema),
        mode: 'onChange',
        defaultValues: {
            email: '',
        },
    });

    useEffect(() => {
        const fetchData = async () => {
            const data = await companyMemberQuery.fetchList();
            setMemberList(data);
        };
        fetchData();
    }, []);

    const invite = handleSubmit(async (data) => {
        // 二重送信ガード (連打で招待メールが複数送信されるのを防ぐ)
        if (inviting) return;
        setInviting(true);
        try {
            await inviteCompanyUserRepository.post(data.email);
            inviteModal.closeModal();
            setShowSnackbar(true);
        } finally {
            setInviting(false);
        }
    });

    return {
        memberList,
        showSnackbar,
        inviteModal,
        needProfileModal,
        errors,
        inviting,
        setShowSnackbar,
        setValue,
        invite,
    };
};
